const colors = [
	"#005ff7",
	"#181d20",
	"#028f4b",
	"#b51522",
	"#edde21",
	"#C71585",
	"#BF4500",
	"#6B30A2",
	"#00b0b0",
	"#DEb887",
	"#F8F8F8",
	"#778899",
	"#302B28",
	"#000810"
]

export const PlayerNameEdit = ({isEditing, setIsEditing, setPlayerName, nameInput, setNameInput, modifyColor}) => {
	if (!isEditing) {
		return null;
	}

	const onSubmitNameChange = (e) => {
		e.preventDefault();
		setPlayerName(nameInput);
		setNameInput('');
		setIsEditing(false);
	}

	const onSubmitColorChange = (colorValue) => {
		modifyColor(colorValue);
		setNameInput('');
		setIsEditing(false);
	}

	return (
		<div>
			<form onSubmit={onSubmitNameChange}>
				<input value={nameInput} onChange={e => setNameInput(e.target.value)} maxLength={24}/>
				<button type="submit">
					Submit
				</button>
			</form>
			{colors.map(colorValue => <button className="ttr-player-color" style={{backgroundColor: colorValue}} onClick={() => onSubmitColorChange(colorValue)}/>)}
		</div>
	);
}